
import * as types from "../types/posTerminals"

const initialState = {}

const ordersOfOrderPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_POS_TERMINAL: {
      const previousTerminals =
        state[action.accountId] || []

      return {
        ...state,
        [action.accountId]: [action.newPosTerminal, ...previousTerminals]
      }
    }
    case types.EDIT_POS_TERMINAL: {
      const previousTerminals =
        state[action.accountId] || []

      return {
        ...state,
        [action.accountId]:
          previousTerminals.map(p =>
            p._id === action.posTerminal._id
              ? action.posTerminal
              : p
          )
      }
    }
    case types.DELETE_POS_TERMINAL: {
      const previousTerminals =
        state[action.accountId] || []

      return {
        ...state,
        [action.accountId]:
          previousTerminals.filter(p =>
            p._id !== action.posTerminalId
          )
      }
    }
    default:
      return state
  }
}

export default ordersOfOrderPageReducer